"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const emotion_1 = require("emotion");
const polaris_1 = require("@amzn/awsui-components-react/polaris");
const md_1 = require("react-icons/md");
const MD_ICONS = {
    MdFormatQuote: md_1.MdFormatQuote,
    MdStorage: md_1.MdStorage,
    MdRepeat: md_1.MdRepeat,
    MdLibraryBooks: md_1.MdLibraryBooks,
    MdPerson: md_1.MdPerson,
    MdDelete: md_1.MdDelete,
    MdDragHandle: md_1.MdDragHandle,
    MdAssignment: md_1.MdAssignment,
};
const Icon = (props) => {
    // TODO: support size, variant, alt
    let name = props.name || '';
    let rotate = '';
    if (name.includes('@')) {
        [name, rotate] = name.split('@');
    }
    let element;
    if (name in MD_ICONS) {
        const MdIcon = MD_ICONS[name];
        element = react_1.default.createElement(MdIcon, { size: 24 });
    }
    else {
        element = react_1.default.createElement(polaris_1.Icon, Object.assign({}, props, { name: name }));
    }
    if (rotate) {
        element = (react_1.default.createElement("span", { className: emotion_1.css({ flexShrink: 0, transform: `rotate(${rotate}deg)` }) }, element));
    }
    return element;
};
Icon.for = (type) => {
    switch (type) {
        case 'termbase':
            return 'MdFormatQuote';
        case 'transmemory':
            return 'MdStorage';
        case 'project':
        case 'shared-project':
            return 'MdRepeat@-45';
        default:
            return type;
    }
};
exports.default = Icon;
//# sourceMappingURL=Icon.js.map